// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class FolderFormView extends JQueryView {
  constructor() {
    super('.permission_form');
  }

  @on({ event: 'click', selector: '.fa-angle' })
  onClickAngle(event: any) {
    const stockholderId = $(event.target).data('stockholderId');
    const id = $(event.target).data('id');

    if ($(event.target).hasClass('fa-angle-right')) {
      $.ajax({
        url: `/company/stockholders/${stockholderId}/documents/${id}`,
        dataType: 'script',
      });
    } else {
      $(event.target)
        .removeClass('fa-angle-down')
        .addClass('fa-angle-right');
      $(`.parent-group-${id}`).hide();
    }
  }

  @on({ event: 'click', selector: '#folder-button' })
  onClickFolderButton(event: any) {
    $('.permission_form').attr('action', $(event.target).data('action'));
  }

  @on({ event: 'click', selector: '#permission-button' })
  onClickPermissionButton(event: any) {
    $('.permission_form').attr('action', $(event.target).data('action'));
  }
}
